















































import {
  Component,
  Emit,
  Model,
  Prop,
  Vue,
  Watch
} from "vue-property-decorator";
import { State, Getter, Action, Mutation } from "vuex-class";
import * as types from "@/store/constants/types";
import CountDown from "@/components/countDown/CountDown.vue";
import GeneralUtilsHelper from "@/utils/generalUtils";
import { sendEvent } from "@/utils/analytics";
import numUtils from "@/utils/numUtils";
import { isIos } from "@/utils/lodash";
import * as statusConst from "@/store/constants/status";
import limitCoinFnc from "@/utils/limitCoinShow";
@Component({
  components: {
    CountDown
  }
})
export default class EarnLimitedCoins extends Vue {
  @Getter(types.GETTER_SETTING_DATA)
  private settingData: any;
  @Getter(types.INITIAL_TIME_STAMP)
  private initTime: any;
  @Action(types.PAY_BY_ANY)
  private payByAny: any;
  @Action(types.ROUTER_PUSH)
  private routerPush: any;
  @Mutation(types.UPDATE_LIMITED_COIN_SHOW)
  private updateLimitShow: any;
  @Getter(types.GETTER_PURCHASED_OFFER)
  private purchasedOffer: any;
  @Getter(types.GETTER_LOCALIZE_PRICE)
  private localizePrice: any;
  @Getter(types.GETTER_LIMITED_COIN_SHOW)
  private isShow: any;
  @Getter(types.GETTER_LIMITED_COIN_INTERVAL_TIME)
  private intervalTime: any;
  @Prop({ default: false })
  private isCached?: boolean;
  @Prop({ default: false })
  private value?: boolean;
  @Prop({ default: "" })
  private status!: string;

  private limited_coin_offers: any;
  private OutStyleWidth: any = 100;
  private intervalTimer: any = null;
  private timeStr: any = ""

  private clickSingle() {
    this.payByAny({
      offer: this.limitedCoinOffers
    }).catch((err: any) => {});

    //GA打点：
    sendEvent("uia_sku_item_click", this.limitedCoinOffers.kind);

    sendEvent("uia_limit_coins_click", "earn_coins_page");
  }

  get localizePriceText() {
    return GeneralUtilsHelper.localizePriceText;
  }

  get limitedCoinOffers() {
    return this.settingData.limited_coin_offers[0];
  }

  get Price() {
    return parseFloat(
      this.settingData.limited_coin_offers[0].iap.price.substring(1)
    );
  }

  get format() {
    return numUtils.format;
  }

  get isHalfCoins() {
    return GeneralUtilsHelper.isHalfCoins();
  }

  get isDoubleCoins() {
    return GeneralUtilsHelper.isDoubleCoins();
  }

  get styleTime() {
    return { animation: "scaleX " + Math.ceil(this.intervalTime) + "s linear" };
  }

  get animationStyle() {
    this.OutStyleWidth = 100 * this.intervalTime / this.settingData.limited_coin.limited_coinoffer_duration;
    return { width: this.OutStyleWidth + "%" };
  }

  @Watch("isShow", { immediate: true })
  private isShowLimtedCoin(val: any, oldVal: any) {
    // console.log("isShowLimtedCoin:>>>", {
    //   val,
    //   oldVal
    // });
    this.$emit("input", this.isShow);

    if (val) {
      sendEvent("uia_limit_coins_show", "earn_coins_page");
    }
  }

  @Watch("intervalTime", { immediate: true })
  private statusChange(val: any, oldVal: any) {
    if(val > 0) {
      val = Math.ceil(val);
      this.countDownTime(val)
    }
  }

  private countDownTime(val: any) {
    this.calcTime(val)
    clearInterval(this.intervalTimer);
    this.intervalTimer = setInterval(() => {
      val--;
      // console.log('val',val)
      this.calcTime(val)
      if(val<=0) {
        this.updateLimitShow(false);
        clearInterval(this.intervalTimer)
        limitCoinFnc.isShowlimiteCoin();
      }
    },1000)
  }
  private calcTime(num: number) {
    let min: any  = Math.floor(num / 60);
    min = min < 10 ? '0' + min : min;
    let sec: any = num % 60;
    sec = sec < 10 ? '0' + sec : sec;
    this.timeStr =  min + ':' + sec;
  }

  private created() {
    limitCoinFnc.isShowlimiteCoin();
  }

  private activated() {
    limitCoinFnc.isShowlimiteCoin();
  }

  private deactivated() {
    clearInterval(this.intervalTimer)
  }

  private beforeDestroy() {
    clearInterval(this.intervalTimer)
  }

}
